module.exports = __webpack_public_path__ + "static/img/3.943a516.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/webgl/ui/img/3.png
// module id = 3u3b
// module chunks = 49